import { QueryClientProvider } from '@tanstack/react-query';
import { AllEnterpriseModule, LicenseManager, ModuleRegistry } from 'ag-grid-enterprise';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from '@/components/ui/sonner';
import { TooltipProvider } from '@/components/ui/tooltip';
import { SessionProvider } from './contexts';
import { AuthProvider } from './contexts/AuthContext';
import { queryClient } from './lib/queryClient';
import './index.css';
import App from './App';

ModuleRegistry.registerModules([AllEnterpriseModule]);

const licenseKey = import.meta.env.VITE_AG_GRID_KEY || import.meta.env.AG_GRID_KEY;
if (licenseKey) {
  LicenseManager.setLicenseKey(licenseKey);
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <TooltipProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <SessionProvider>
            <App />
            <Toaster position="bottom-right" richColors />
          </SessionProvider>
        </AuthProvider>
      </QueryClientProvider>
    </TooltipProvider>
  </React.StrictMode>
);
